import { Input } from "@/components/ui/input";

const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

const mes = (offset) => {
  const n = new Date();
  return { de: iso(new Date(n.getFullYear(), n.getMonth() + offset, 1)), ate: iso(new Date(n.getFullYear(), n.getMonth() + offset + 1, 0)) };
};

const OPCOES = [
  ["tudo", "Tudo", () => ({ de: "", ate: "" })],
  ["mes", "Este mês", () => mes(0)],
  ["anterior", "Mês passado", () => mes(-1)],
  ["periodo", "Período", null],
];

export const PeriodoFiltro = ({ periodo, onChange }) => (
  <div className="mb-6 space-y-3" data-testid="mv-periodo">
    <div className="flex flex-wrap gap-2">
      {OPCOES.map(([v, l, fn]) => (
        <button key={v} data-testid={`mv-periodo-${v}`}
          onClick={() => onChange(fn ? { tipo: v, ...fn() } : { ...periodo, tipo: v })}
          className={`rounded-full px-4 py-2 text-sm font-semibold border-2 transition-colors ${periodo.tipo === v ? "border-primary bg-primary text-primary-foreground" : "border-border text-muted-foreground hover:text-foreground"}`}>{l}</button>
      ))}
    </div>
    {periodo.tipo === "periodo" && (
      <div className="grid grid-cols-2 gap-2 max-w-md">
        <label className="min-w-0 text-xs text-muted-foreground">De
          <Input type="date" data-testid="mv-de" value={periodo.de} onChange={(e) => onChange({ ...periodo, de: e.target.value })} className="mt-1 bg-card min-w-0 w-full px-2 text-sm" />
        </label>
        <label className="min-w-0 text-xs text-muted-foreground">Até
          <Input type="date" data-testid="mv-ate" value={periodo.ate} onChange={(e) => onChange({ ...periodo, ate: e.target.value })} className="mt-1 bg-card min-w-0 w-full px-2 text-sm" />
        </label>
      </div>
    )}
  </div>
);
